import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import { exportToExcel } from "../../../common/CommonFunctions";
import {
  getComparator,
  handleChangePage,
  handleChangeRowsPerPage,
  handleRequestSort,
  stableSort,
} from "../../../common/MuiTableFunctions.config";
import EditIcon from "../../../assets/images/Edit.svg";
import ViewIcon from "../../../assets/images/View.svg";
import DeleteIcon from "../../../assets/images/Delete.svg";
import NCActivitiesManagementModal from "./NCActivitiesManagementModal";
import WarningModalForActivityDelete from "./WarningModalForActivityDelete";

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: "grid",
  },
}));

const DataTableToUpdateNCActivityOfThirdPartyAudit = ({
  RowData = [],
  Columns,
  RowsToDisplay,
  OptionsForRowsPerPage,
  HoverEffect,
  DenseTable,
  RequiredSearch,
  DataToBeExport,
  FileNameForExportData,
  HeaderFontSize,
  // IsOutSideSearch,

  // Realated to activity point update
  HandleChangeInNCActivityTable,
  HandleToggleNCActivityModal,
  NCActivityModalState,

  // Other Imp data
  IsAdmin,
  IsSuperAdmin,
  IsUser,
  IsViewMode,
  IsAuditStatusDraft,
  IsAuditStatusReviewPending,
  IsAuditStatusCompleted,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(Columns[0].id);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(RowsToDisplay || 10);

  // Activity Delete Warning Modal
  const [activityDeleteWarningModal, setActivityDeleteWarningModal] = useState({
    isOpen: false,
    data: null,
  });

  const toggleDeleteActivityModal = (data = null, isOpen = false) => {
    setActivityDeleteWarningModal((prev) => ({
      ...prev,
      data: data,
      isOpen: isOpen,
    }));
  };

  return (
    <React.Fragment>
      {NCActivityModalState?.isOpen && (
        <NCActivitiesManagementModal
          ToggleFunction={HandleToggleNCActivityModal}
          Open={NCActivityModalState?.isOpen}
          Data={NCActivityModalState?.data}
          ModalType={NCActivityModalState?.type}
          UpdateParentData={(action, id, data) =>
            HandleChangeInNCActivityTable(action, id, data)
          }
        />
      )}
      {activityDeleteWarningModal?.isOpen && (
        <WarningModalForActivityDelete
          Data={activityDeleteWarningModal?.data}
          OnSubmit={(action, id, data) =>
            HandleChangeInNCActivityTable(action, id, data)
          }
          Open={activityDeleteWarningModal?.isOpen}
          ToggleFunction={toggleDeleteActivityModal}
        />
      )}
      <Paper sx={{ width: "100%", mb: 2, borderRadius: "5px" }}>
        {(RequiredSearch || DataToBeExport) && (
          <div
            className="d-flex align-items-center py-2 ps-2 pe-3"
            style={{
              background: "rgba(224, 224, 224, 0.4)",
              borderRadius: "5px 5px 0 0",
            }}
          >
            <div className="d-flex align-items-center gap-1">
              {DataToBeExport && (
                <AppButton
                  Type={"submit"}
                  OnPress={() => {
                    exportToExcel(RowData, Columns, FileNameForExportData);
                  }}
                  Size={"small"}
                  ClassName={"ms-2"}
                  children={"Export"}
                />
              )}
            </div>
          </div>
        )}
        <TableContainer
          style={
            RequiredSearch || DataToBeExport
              ? {}
              : {
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                }
          }
        >
          <Table
            size={DenseTable ? "small" : "medium"}
            className="rounded rounded-2"
          >
            <TableHead style={{ background: "rgba(224, 224, 224, 0.4)" }}>
              <TableRow>
                {Columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sortDirection={orderBy === column.id ? order : false}
                    style={{
                      cursor: "pointer",
                      padding: "auto",
                      fontSize: HeaderFontSize || "13px",
                    }}
                    align={column.headerAlign || "left"}
                  >
                    {column.isSort ? (
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(
                            order,
                            orderBy,
                            column.id,
                            setOrder,
                            setOrderBy
                          )
                        }
                      >
                        <Typography
                          className="inter-medium-300"
                          variant="inherit"
                        >
                          {column.label}
                        </Typography>
                      </TableSortLabel>
                    ) : (
                      <Typography
                        className="inter-medium-300"
                        variant="inherit"
                      >
                        {column.label}
                      </Typography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {RowData && RowData[0] ? (
                stableSort(RowData, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover={HoverEffect ? true : false}
                        role={"row"}
                        tabIndex={-1}
                        key={row.id}
                      >
                        {Columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.cellAlign || "left"}
                            sx={{
                              padding: "auto",
                              maxWidth: column.columnWidth,
                            }}
                          >
                            {column?.id === "actions" ? (
                              <div className="d-flex align-items-center gap-3 justify-content-center">
                                <img
                                  src={ViewIcon}
                                  className="cursor-pointer"
                                  alt={"View"}
                                  style={{ width: "20px", height: "20px" }}
                                  onClick={() => {
                                    HandleToggleNCActivityModal(
                                      row,
                                      true,
                                      "VIEW"
                                    );
                                  }}
                                />
                                {!IsViewMode && IsAuditStatusDraft && (
                                  <img
                                    src={EditIcon}
                                    className="cursor-pointer"
                                    alt={"Edit"}
                                    style={{ width: "20px", height: "20px" }}
                                    onClick={() => {
                                      HandleToggleNCActivityModal(
                                        row,
                                        true,
                                        "UPDATE"
                                      );
                                    }}
                                  />
                                )}
                                {!IsViewMode && IsAuditStatusDraft && (
                                  <img
                                    src={DeleteIcon}
                                    className="cursor-pointer"
                                    alt={"Delete"}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                    onClick={() => {
                                      const data = {
                                        action: "DELETE",
                                        id: row?.id,
                                        obj: row,
                                      };
                                      toggleDeleteActivityModal(data, true);
                                    }}
                                  />
                                )}
                              </div>
                            ) : column?.id === "attachments" ? (
                              <Typography
                                className="inter-medium-300"
                                variant="inherit"
                              >
                                {row.attachments?.length > 0
                                  ? `${row.attachments.length} file${
                                      row.attachments.length > 1 ? "s" : ""
                                    } uploaded`
                                  : "Not uploaded yet"}
                              </Typography>
                            ) : (
                              <Typography
                                className="inter-medium-300"
                                variant="inherit"
                              >
                                {row[column.id] || "Not Available"}
                              </Typography>
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow hover={HoverEffect ? true : false} role={"row"}>
                  <TableCell
                    align={"center"}
                    sx={{ padding: "auto" }}
                    colSpan={Columns?.length}
                  >
                    <Typography
                      variant="subtitle2"
                      className="inter-regular-400 my-3"
                    >
                      There are no records to display
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={OptionsForRowsPerPage || [5, 10, 25]}
          component="div"
          className="custom-mui-pagination"
          slotProps={{
            select: {
              MenuProps: {
                MenuListProps: {
                  classes: {
                    root: classes.menuItem,
                  },
                  sx: {
                    "& .MuiMenuItem-root": {
                      padding: "5px 8px",
                    },
                  },
                },
              },
            },
          }}
          count={RowData && RowData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, page) => handleChangePage(event, page, setPage)}
          onRowsPerPageChange={(event) =>
            handleChangeRowsPerPage(event, setRowsPerPage, setPage)
          }
        />
      </Paper>
    </React.Fragment>
  );
};

export default DataTableToUpdateNCActivityOfThirdPartyAudit;
